<template>
<az-container>
  <div class="az-form-content">
    <lista-tipos-selecao
        :tipos="tiposBuscaDocumentosLinha1"
        :tipo-selecionado="tipoSelecionado"
        @selecionar="selecionarTipoBusca"
    />
    <lista-tipos-selecao
        :tipos="tiposBuscaDocumentosLinha2"
        :tipo-selecionado="tipoSelecionado"
        @selecionar="selecionarTipoBusca"
    />
  </div>
</az-container>
</template>

<script>
import ListaTiposSelecao from '@/commons/components/ListaTiposSelecao.vue'
import ProtocoloBusca from '@/views/licitacao/detalhe/orgao/protocolos/ProtocoloBusca.vue'

export default {
  name: "ProtocoloSelecionarBusca",
  components: {ProtocoloBusca, ListaTiposSelecao},
  data(){
    return {
      tipoSelecionado: null,
      ativarBusca: false,
      tiposBuscaDocumentosLinha1: [
        {
          id: 1,
          label: 'Protocolo da Proposta',
          nome: 'PROTOCOLO_DOCUMENTO',
          icon: null,
          iconeRotacionado: true,
          selecionado: false
        },
        {
          id: 2,
          label: 'Documentos de Proposta/Habilitação',
          nome: 'PROPOSTA_DOCUMENTO',
          icon: null,
          selecionado: false
        },
      ],
      tiposBuscaDocumentosLinha2: [
        {
          id: 3,
          label: 'Protocolo de Recurso',
          nome: 'RECURSO_ANEXO',
          icon: null,
          selecionado: false
        },
        {
          id: 4,
          label: 'Protocolo de Contrarrazão',
          nome: 'CONTRARRAZAO_ANEXO',
          icon: null,
          selecionado: false
        }
      ],
    }
  },
  methods:{
    selecionarTipoBusca(tipoBusca){
      this.tipoSelecionado = tipoBusca.nome
      setTimeout(() => {
        this.$router.push({name: 'protocolosLista', params: {tipo: this.tipoSelecionado}})
      }, 500)

    }
  }
}
</script>

<style scoped lang="stylus">


</style>